import { render, staticRenderFns } from "./TaskStatusSelector.vue?vue&type=template&id=3901e82c&"
import script from "./TaskStatusSelector.vue?vue&type=script&lang=js&"
export * from "./TaskStatusSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports